export interface PreHeadingModel {
  items: PreHeadingModelItem[];
  horizontal_scroll?: boolean;
  alignment: PreHeadingAlignment;
  background_color?: string;
}

export interface PreHeadingModelItem {
  link: string,
  text: string,
  color?: string;
}

export enum PreHeadingAlignment {
  LEFT= 'LEFT', RIGHT = 'RIGHT', CENTER = 'CENTER'
}
